;(function() {
angular.module("firmaren")
  .component("authorizationContact", {
    templateUrl: "/app/shared/authorization-contact/authorization-contact.html",
    controllerAs: "vm",
    bindings: {
      model: "=",
      form: "=",
      submitted: "="
    }
  });
}());
